import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserRoles } from 'src/app/app.enums';
import { AuthGuard } from 'src/app/components/Guards/authGuard';
import { ApplicationLogComponent } from 'src/app/components/admin-level/all-galleries/application-log/application-log.component';
import { GalleriesComponent } from 'src/app/components/admin-level/all-galleries/galleries.component';
import { ArtTypeComponent } from 'src/app/components/admin-level/art-type/art-type.component';
import { EmailSettingsComponent } from 'src/app/components/admin-level/email-settings-template/email-settings.component';
import { ArtistsComponent } from 'src/app/components/admin-level/artists/artists.component';
import { EmailTrackLogComponent } from 'src/app/components/admin-level/all-galleries/email-track-log/email-track-log.component';
import { SubscriptionRulesComponent } from 'src/app/components/admin-level/subscription-rules/subscription-rules.component';
import { SystemSettingsComponent } from 'src/app/components/admin-level/system-settings/system-settings.component';
import { AdminsComponent } from 'src/app/components/admin-level/admins/admins.component';
import { EmailEventComponent } from 'src/app/components/admin-level/email-events/email-events.component';
import { SystemEventsWorkflowComponent } from 'src/app/components/admin-level/System-Events-Workflow/system-events-workflow.component';
import { SMSSettingsComponent } from 'src/app/components/admin-level/sms-settings/sms-settings.componenet';

const routes: Routes = [
    {
        path: 'view',
        component: ArtistsComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator] }
    },
    {
        path: 'admins',
        component: AdminsComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin] }
    },
    {
        path: 'application-log',
        component: ApplicationLogComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator] }
    },
    {
        path: 'email-track-log',
        component: EmailTrackLogComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator] }
    },
    {
        path: 'view-galleries',
        component: GalleriesComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator] }
    },
    {
        path: 'art-type',
        component: ArtTypeComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator] }
    },
    {
        path : 'email-events',
        component: EmailEventComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator]}
    },
    {
        path: 'email-templates',
        component: EmailSettingsComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator] }
    },
    {
        path: 'sms-templates',
        component: SMSSettingsComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator] }
    },
    {
        path: 'system-events-workflow',
        component: SystemEventsWorkflowComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator] }
    },
    {
        path: 'subscription-rules',
        component: SubscriptionRulesComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator] }
    },
    {
        path:'system-settings',
        component: SystemSettingsComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.SuperAdmin, UserRoles.Administrator]}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdminRoutingModule { }
